import Vue from 'vue';
import { MutationTree } from 'vuex';
import { AdminInfoModel } from '@/models/AdminInfo';
import { UpdateHistoryModel } from '@/models/UpdateHistory';
import ToolState from './state';
import { MutationTypes } from './mutation-types';

const mutations: MutationTree<ToolState> = {
    [MutationTypes.LOAD_ADMIN](state: ToolState, adminInfo: AdminInfoModel) {
        state.adminInfo = adminInfo;
    },

    [MutationTypes.LOAD_HISTORY](state: ToolState, histories: UpdateHistoryModel[]) {
        for (const history of histories) {
            state.histories.push(history);
        }
    },
};

export default mutations;
